import gql from 'graphql-tag';

export const COMPLETE_STAGE = gql`
  mutation CompleteStage($input: CompleteBusinessProcessFlowStageInput!, $parentId: ID!, $parentType: BPFLinkType!) {
    bpf {
      result: completeStage(input: $input) {
        error
        success
        entity {
          fieldValues(parentId: $parentId, parentType: $parentType) {
            id
            isCompleted
            completedById
            completedDateTime
            completedBy {
              id
              fullName
            }
          }
        }
      }
    }
  }
`;
